import * as React from "react";
const SvgClose = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 13L13 1M1 1L13 13", stroke: "black", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClose;
